import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { InboundPopup } from "@/components/inbox/InboundPopup";
import { ClientModal } from "@/components/client/ClientModal";
import { beep } from "@/components/inbox/inboxUtils";

const Ctx = createContext({ items: [], open: 0, reload: () => {}, openClient: () => {} });
export const useInbox = () => useContext(Ctx);

const keyOf = (t) => `${t.wa_id}|${t.last_at}`;

export const InboxProvider = ({ children }) => {
  const [data, setData] = useState({ items: [], open: 0 });
  const [hidden, setHidden] = useState(() => new Set(JSON.parse(sessionStorage.getItem("wa_hidden") || "[]")));
  const [clientId, setClientId] = useState(null);
  const seen = useRef(null);

  const reload = useCallback(async () => {
    try {
      const { data: d } = await api.get("/wa/threads", { params: { status: "open" } });
      const keys = d.items.map(keyOf);
      if (seen.current && keys.some((k) => !seen.current.has(k))) {
        beep();
        if (document.hidden && "Notification" in window && Notification.permission === "granted") {
          const t = d.items[0];
          new Notification("Cliente respondeu no Financeiro", { body: `${t.client?.name || t.phone}: ${t.last_text}` });
        }
      }
      seen.current = new Set(keys);
      setData(d);
    } catch { /* keep last state */ }
  }, []);

  useEffect(() => {
    if ("Notification" in window && Notification.permission === "default") Notification.requestPermission();
    reload();
    const t = setInterval(reload, 15000);
    return () => clearInterval(t);
  }, [reload]);

  const hide = (t) => {
    const next = new Set(hidden); next.add(keyOf(t)); setHidden(next);
    sessionStorage.setItem("wa_hidden", JSON.stringify([...next]));
  };
  const visible = data.items.filter((t) => !hidden.has(keyOf(t)));

  return (
    <Ctx.Provider value={{ ...data, reload, openClient: setClientId }}>
      {children}
      {!clientId && <InboundPopup items={visible} onHide={hide} onHandled={reload} onOpenClient={setClientId} />}
      {clientId && <ClientModal id={clientId} onClose={() => setClientId(null)} />}
    </Ctx.Provider>
  );
};
